module.exports = __webpack_public_path__ + "img/503522_C38254_9F6B45_845838-256px.f75f1c15.png";